<script setup lang="ts">
import type { IElement } from '~/interfaces/form/formBuilder';

defineProps<{
  element: IElement;
}>();
</script>

<template>
  <div class="text-base-priority font-bold mb-2">
    {{ $t(element.label) }}
  </div>
</template>